<button
	svc-filled-btn-icon
	type="button"
	class="rounded-full"
	[class]="small ? null : 'w-10 h-10 max-w-none max-h-none'" 
	[iconSize]="small ? 5 : 7"
	[icon]="step === 'TO_RECORD' ? 'heroicons_mini:microphone' : 'mat_solid:stop'"
	[class.svc-default]="isThemeSolvace"
	[color]="(disabled || false) ? 'text' : 'primary'" 
	[disabled]="disabled || false"
	[processing]="loading || false"
	[matMenuTriggerFor]="!isRecording && canChooseRecording ? matMenu : null"
	(click)="onClick()"
></button>

<mat-menu #matMenu xPosition="before">
	<button mat-menu-item (click)="recordAudio(ActionType.RECORD_AUDIO)">{{ 'Gravar áudio' | transloco }}</button>
	<button mat-menu-item (click)="recordAudio(ActionType.AUDIO_TO_TEXT)">{{ 'Voz para texto' | transloco }}</button>
</mat-menu>
